import { copyShareUrl } from '../../services/shareLinks';

interface CopyLinkButtonProps {
  /** The public share URL, or null when the entity has no id yet. */
  url: string | null;
  /** What the link points at, for the tooltip: "Copy link to this brand". */
  noun: string;
}

/**
 * The header "Copy link" icon on the entity editors. Copies the public
 * `https://app.watchkeeper.tech/...` link (the same one the Share Links page
 * builds) and toasts. Renders nothing without a URL, so a create-mode editor —
 * which has no id to link to — simply has no button.
 */
export function CopyLinkButton({ url, noun }: CopyLinkButtonProps) {
  if (!url) return null;
  const label = `Copy link to this ${noun}`;
  return (
    <button
      type="button"
      onClick={() => void copyShareUrl(url)}
      className="text-gray-400 hover:text-brand-600 transition-colors"
      title={label}
      aria-label={label}
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
        />
      </svg>
    </button>
  );
}
